import { render, staticRenderFns } from "./RealTimeUserTable.vue?vue&type=template&id=19489a4e&scoped=true"
import script from "./RealTimeUserTable.vue?vue&type=script&lang=js"
export * from "./RealTimeUserTable.vue?vue&type=script&lang=js"
import style0 from "./RealTimeUserTable.vue?vue&type=style&index=0&id=19489a4e&prod&lang=scss"
import style1 from "./RealTimeUserTable.vue?vue&type=style&index=1&id=19489a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19489a4e",
  null
  
)

export default component.exports